<template>
  <div style='height: calc(100vh - 82px);padding-left: 10px;'>
    <div class='searchDiv'>
      <div>
        <el-select v-model="build" size="small" style='width: 200px;' filterable placeholder="请选择栋舍" clearable @change="buildSelect">
          <el-option
            v-for="item in buildList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="apartment" size="small" style='width: 200px;margin-left: 10px;' filterable clearable placeholder="请选择单元">
          <el-option
            v-for="item in apartmentList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
        <el-input v-model="sn" size="small" style='width: 200px;margin-left: 10px;' placeholder="请输入序列号"></el-input>
        <el-input v-model="name" size="small" style='width: 200px;margin-left: 10px;' placeholder="请输入料塔名称"></el-input>
        <el-button type="primary" style='margin-left: 10px' size="small" @click='searchFodderView()'>查询</el-button>
        <el-button type="primary" style='margin-left: 10px' size="small" @click='reset()'>重置</el-button>
      </div>
      <div class='icon-list'>
        <div :class='isList ? "" : "isList-active"'>
          <i @click='isList = false' class='iconfont'>&#xe602;</i>
        </div>
        <div :class='!isList ? "" : "isList-active"'>
          <i @click='isList = true' class='iconfont'>&#xe659;</i>
        </div>
      </div>
      <!-- <div>
        <el-select v-model="sort" size="small" @change='sortChange' style='width: 150px;' clearable placeholder="请选择排序字段">
          <el-option
            v-for="item in sortList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </div> -->
    </div>

    <!--<el-row class='bottom' :gutter="20">
      <el-col :span='8' v-for='item in viewList' :key='item.id'>
        <div class='bottom_div' @click='viewClick(item)'>
          <div class='bottom_left'>
            <div>容量：{{ parseInt((item.range / 1000)*10)/10 }} T</div>
            <div>
              <img src='@/assets/img/fodder.jpg' style='width: 100%;height: 100%;'>
            </div>
            <el-tooltip class="item" effect="dark" :content="item.name || '-'" placement="top">
              <div class='text-ellipsis' :title="item.name">{{ item.name }}</div>
            </el-tooltip>
          </div>
          <div class='bottom_right'>
            <el-tooltip class="item" effect="dark" :content="'最后通信时间：' + (item.lastTime || '-')" placement="top">
              <div v-if='item.isOnline === "0"' class='isOnline'>离线</div>
            </el-tooltip>
            <div style='margin-top: 10px;'>今日消耗</div>
            <div>{{ parseInt((item.outgoing / 1000)*10)/10 }} T</div>
            <div>自上次来料消耗</div>
            <div>{{ parseInt((item.outgoingLastIncoming / 1000)*10)/10 }} T</div>
            <div>余料预计可用天数</div>
            <div>&lt; {{ item.stableUseDays }} 天</div>
            <div>今日来料</div>
            <div>{{ parseInt((item.incoming / 1000)*10)/10 }} T</div>
          </div>
        </div>
      </el-col>
    </el-row> -->

    <el-row class="bottom" :gutter="20" v-if='!isList'>
      <el-col :span="8" v-for="item in viewList" :key="item.id">
        <div class="bottom-div" @click="viewClick(item)">
          <div class="bottom-left">
            <div class="capacity">容量：<b>{{ parseInt((item.range / 1000) * 10) / 10 }} T</b></div>
<!--            <div class="image-container">-->
<!--              <img class="image" src="@/assets/img/fodder.png" alt="Image" />-->
<!--            </div>-->
<!--            <div class="image-container">-->
<!--              <div class="fill" :style="{ transform: getFillHeight(item.stablePercent) }"></div>-->
<!--              <img class="image" src="@/assets/img/fodder.png" alt="Image" />-->
<!--            </div>-->
            <div class="image-container">
              <feed-store :width="115" :height="153"
                          :percent="Number(item.stablePercent)"
                          :store="item.stableValue?(item.stableValue+item.stableUnit):''"
                          :stableValue='item.stableValue'
                          :can_id="item.sn" />
            </div>
            <el-tooltip class="item" effect="dark" :content="item.name || '-'" placement="top">
              <div class="text-ellipsis">{{ item.name }}</div>
            </el-tooltip>
          </div>
          <div class="bottom-right">
<!--            <el-tooltip effect="dark" :content="'最后通信时间：' + (item.lastTime || '-')" placement="top">-->
<!--              <div v-if="item.isOnline === '0'" class="isOnline">-->
<!--                离线-->
<!--              </div>-->
<!--            </el-tooltip>-->
<!--            <el-tooltip effect="dark" content="数据异常" placement="top">-->
<!--              <div v-if="parseInt((item.range / 1000) * 10) / 10 > 40 || parseInt((item.range / 1000) * 10) / 10 < 40" class="isAbnormal">-->
<!--                异常-->
<!--              </div>-->
<!--            </el-tooltip>-->

            <el-carousel
              height="20px"
              direction="vertical"
              indicator-position="none"
              arrow="never"
              class='carousel'
            >
              <el-carousel-item  v-if="item.isOnline === '0'">
                <el-tooltip
                  effect="dark"
                  :content="'最后通信时间：' + (item.lastTime || '-')"
                  placement="top"
                >
                  <div class="isOnline">
                    离线
                  </div>
                </el-tooltip>
              </el-carousel-item>
              <el-carousel-item v-if="parseInt((item.range / 1000) * 10) / 10 > 40 || parseInt((item.range / 1000) * 10) / 10 < -40">
                <el-tooltip
                  effect="dark"
                  content="数据异常"
                  placement="top"
                >
                  <div class="isAbnormal">
                    异常
                  </div>
                </el-tooltip>
              </el-carousel-item>
            </el-carousel>

            <div v-if="item.isOnline !== '0'" style='height: 16px'></div>
            <div class="right-div">
              <div class="consumption-item">
                <div class="consumption-title">今日消耗</div>
                <div class="consumption-value">{{ item.outgoing !== null ? parseInt((item.outgoing / 1000) * 10) / 10 + ' T' : '-' }}</div>
              </div>
              <div class="consumption-item">
                <div class="consumption-title">来料后累计消耗</div>
<!--                <div class="consumption-value">{{ parseInt((item.outgoingLastIncoming / 1000) * 10) / 10 }} T</div>-->
                <div class="consumption-value">{{ item.outgoingLastIncoming !== null ? parseInt((item.outgoingLastIncoming / 1000) * 10) / 10 + ' T' : '-' }}</div>
              </div>
              <div class="consumption-item">
                <div class="consumption-title">余料天数</div>
                <div class="consumption-value"
                     :style='item.stableUseDays?item.stableUseDays === 3?{color: "#ffcc00"}:item.stableUseDays < 3?{color: "red"}:"":""'>
<!--                  &lt;-->
<!--                  ≤ {{ item.stableUseDays || '?' }} 天-->
                  <div class="consumption-value">{{ item.stableUseDays !== null ? '≤' + item.stableUseDays + ' 天' : '-' }}</div>
                </div>
              </div>
              <div class="consumption-item">
                <div class="consumption-title">今日来料</div>
<!--                <div class="consumption-value">{{ parseInt((item.incoming / 1000) * 10) / 10 }} T</div>-->
                <div class="consumption-value">{{ item.incoming !== null ? parseInt((item.incoming / 1000) * 10) / 10 + ' T' : '-' }}</div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="bottom2" v-if='isList'>
      <el-table
        :data="tableData"
        class='table'
        @row-click='viewClick'
        style="width: 100%">
        <el-table-column
          prop="name"
          label="料塔名称">
        </el-table-column>
        <el-table-column
          prop="outgoing"
          width='120'
          sortable
          label="今日消耗">
          <template slot-scope="scope">
<!--            <div>{{ scope.row.outgoing !== null ? parseInt((scope.row.outgoing / 1000) * 10) / 10 + ' T' : '-' }}</div>-->
            <div>{{ scope.row.outgoing !== null ? scope.row.outgoing + ' kg' : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="range"
          width='100'
          label="容量">
<!--          <template slot-scope="scope">-->
<!--            <div>{{ parseInt((scope.row.range / 1000) * 10) / 10 }} T</div>-->
<!--            <div>{{ scope.row.range }} kg</div>-->
<!--          </template>-->

          <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  content="数据异常"
                  placement="top"
                >
                  <div class="tableIsAbnormal" style='width: 34px;height: 18px;'
                       v-if="parseInt((scope.row.range / 1000) * 10) / 10 > 40 || parseInt((scope.row.range / 1000) * 10) / 10 < -40">
                    异常
                  </div>
                </el-tooltip>
            <div>{{ scope.row.range }} kg</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="stableUseDays"
          sortable
          width='120'
          label="余料天数">
          <template slot-scope="scope">
            <div :style='scope.row.stableUseDays?scope.row.stableUseDays === 3?{color: "#ffcc00"}:scope.row.stableUseDays < 3?{color: "red"}:"":""'>
              <div>{{ scope.row.stableUseDays !== null ? '≤' + scope.row.stableUseDays + ' 天' : '-' }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="outgoingLastIncoming"
          sortable
          width='150'
          label="来料后累计消耗">
          <template slot-scope="scope">
<!--            <div>{{ scope.row.outgoingLastIncoming !== null ? parseInt((scope.row.outgoingLastIncoming / 1000) * 10) / 10 + ' T' : '-' }}</div>-->
            <div>{{ scope.row.outgoingLastIncoming !== null ? scope.row.outgoingLastIncoming + ' kg' : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="incoming"
          sortable
          width='120'
          label="今日来料">
          <template slot-scope="scope">
<!--            <div>{{ scope.row.incoming !== null ? parseInt((scope.row.incoming / 1000) * 10) / 10 + ' T' : '-' }}</div>-->
            <div>{{ scope.row.incoming !== null ? scope.row.incoming + ' T' : '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="isOnline"
          sortable
          label="状态">
          <template slot-scope="scope">
            <span style='color: red;' v-if='scope.row.isOnline === "0"'>离线</span>
            <span style='color: green;' v-else>在线</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <el-row class="bottom" :gutter="20">
      <el-col :span="8" v-for="item in viewList" :key="item.id">

        <div>
          <feed-store :width="96" :height="128"
                      :percent="Number(item.stablePercent)"
                      :store="item.stableValue?(item.stableValue+item.stableUnit):''"
                      :can_id="item.sn" />
        </div>
      </el-col>
    </el-row>

    <el-row class="bottom" :gutter="20">
      <el-col :span="8" v-for="item in viewList" :key="item.id">
        <div class="bottom-div" @click="viewClick(item)">
          <div class="image-container">
            <img class="image" src="@/assets/img/fodder.jpg" alt="Image" />
            <div class="name">{{ item.name }}</div>
            <div v-if="item.isOnline === '0'" class="offline-status" :title="'最后通信时间：' + (item.lastTime || '-')">
              离线
            </div>
          </div>
          <div class="bottom-right">
            <div class="consumption-item">
              <div class="consumption-title">容量</div>
              <div class="consumption-value">{{ parseInt((item.range / 1000) * 10) / 10 }} T</div>
            </div>
            <div class="consumption-item">
              <div class="consumption-title">今日消耗</div>
              <div class="consumption-value">{{ parseInt((item.outgoing / 1000) * 10) / 10 }} T</div>
            </div>
            <div class="consumption-item">
              <div class="consumption-title">自上次来料消耗</div>
              <div class="consumption-value">{{ parseInt((item.outgoingLastIncoming / 1000) * 10) / 10 }} T</div>
            </div>
            <div class="consumption-item">
              <div class="consumption-title">余料预计可用天数</div>
              <div class="consumption-value">&lt; {{ item.stableUseDays }} 天</div>
            </div>
            <div class="consumption-item">
              <div class="consumption-title">今日来料</div>
              <div class="consumption-value">{{ parseInt((item.incoming / 1000) * 10) / 10 }} T</div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="bottom">
      <div class="container">
        <div class="item" v-for="item in viewList" :key="item.id" @click="viewClick(item)">
          <div class="left">
            <img src="@/assets/img/fodder.jpg" alt="Image" />
          </div>
          <div class="right">
            <div class="title">{{ item.name }}</div>
            <div class="info">容量：{{ formatCapacity(item.range) }}</div>
            <div class="info">最后通信时间：{{ item.lastTime || '-' }}</div>
            <div class="info">今日消耗：{{ formatCapacity(item.outgoing) }}</div>
            <div class="info">自上次来料消耗：{{ formatCapacity(item.outgoingLastIncoming) }}</div>
            <div class="info">余料预计可用天数：&lt; {{ item.stableUseDays }} 天</div>
            <div class="info">今日来料：{{ formatCapacity(item.incoming) }}</div>
          </div>
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import feedStore from './components/CustFeedStore.vue'
export default {
  name: 'fodderView',
  components: {
    feedStore,
  },
  data() {
    return {
      buildList: [],
      apartmentList: [],
      tableData: [],
      sort: '',
      isList: false,
      sortList: [
        {
          id: 'stablePercent',
          name: '余料百分比',
        },
        {
          id: 'outgoing',
          name: '今日耗料',
        },
        {
          id: 'stableUseDays',
          name: '可用天数',
        },
      ],
      build: '',
      apartment: '',
      sn: '',
      name: '',
      viewList: [],
      sortViewList: [],
      isIncoming: this.$store.state.fodder.isIncoming,
      isTowerCount: this.$store.state.fodder.isTowerCount,
      isOutgoing: this.$store.state.fodder.isOutgoing,
    }
  },
  mounted(){
    this.startTimer();
    this.getPigBuildList();
    this.getApartmentList();
    this.getFodderView();
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods:{
    getFillHeight(stablePercent) {
      const percent = parseFloat(stablePercent);
      return `scaleY(${percent}%)`;
    },
    startTimer() {
      // 每隔三分钟调用一次接口
      this.timer = setInterval(() => {
        this.getPigBuildList();
        this.getApartmentList();
        this.getFodderView();
      }, 3 * 60 * 1000); // 三分钟，单位为毫秒
    },
    stopTimer() {
      // 停止定时器
      clearInterval(this.timer);
    },
    getFodderView(){
      let param = {
        buildId: this.build,
        unitId: this.apartment,
        sn: this.sn,
        name: this.name,
      }
      this.$http.post(this.$api.getTowerView,param).then(res => {
        this.viewList = res.result;
        this.sortViewList = res.result;
        this.tableData = res.result;
        this.viewList.sort((a,b) =>{
          return b.isOnline - a.isOnline
        });
        if (this.isIncoming){
          this.viewList = this.sortViewList.filter(item => item.incoming > 0);
          this.tableData = this.sortViewList.filter(item => item.incoming > 0);
        }
        if (this.isTowerCount){
          this.viewList = this.sortViewList.filter(item => Number(item.stablePercent) < 20);
          this.tableData = this.sortViewList.filter(item => Number(item.stablePercent) < 20);
        }
        if (this.isOutgoing){
          this.viewList = this.sortViewList.filter(item => item.outgoing > 0);
          this.tableData = this.sortViewList.filter(item => item.outgoing > 0);
        }
      })
    },
    searchFodderView(){
      let arr = this.sortViewList;
      if (!this.name && !this.sn && !this.apartment && !this.build){
        this.viewList = arr;
        this.tableData = arr;
      }else {
        if (this.build){
          arr = arr.filter(item => item.buildId ? item.buildId.includes(this.build) : false)
        }
        if (this.apartment){
          arr = arr.filter(item => item.unitId ? item.unitId.includes(this.apartment) : false)
        }
        if (this.name){
          arr = arr.filter(item => item.name ? item.name.includes(this.name) : false)
        }
        if (this.sn){
          arr = arr.filter(item => item.sn ? item.sn.includes(this.sn) : false)
        }
        this.viewList = arr;
        this.tableData = arr;
      }
    },
    reset(){
      this.build = '';
      this.apartment = '';
      this.sn = '';
      this.name = '';
      this.$store.commit('setIsTowerCount', false);
      this.$store.commit('setIsIncoming', false);
      this.$store.commit('setIsOutgoing', false);
      this.isIncoming = false;
      this.isTowerCount = false;
      this.isOutgoing = false;
      this.getFodderView();
    },
    sortChange(e){
      let arr = this.sortViewList;
      this.viewList = arr.sort((a, b) => {
        return b[e] - a[e];
      });
    },
    viewClick(e){
      localStorage.setItem('routename', '料塔详情');
      localStorage.setItem('routetarget', 'viewDetails');
      this.$store.commit('selectMenu', {
        id: "213132431",
        type: "menu",
        name: "料塔详情",
        router: "fodder/viewDetails",
        target: "viewDetails",
        icon: "&#xe610;",
      });
      this.$store.commit('setDetailsData', e);
      this.$router.push({
        path: 'viewDetails',
      });
    },
    //栋舍
    getPigBuildList() {
      this.$http.post(this.$api.getPigBuildList,{
        type: 2,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.buildList = res.result;
      })
    },
    //单元
    getApartmentList(type = '0') {
      this.$http.post(this.$api.getPigBuildList,{
        type,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.apartmentList = res.result;
      })
    },
    buildSelect(e){
      this.apartment = '';
      this.$http.post(this.$api.getPigBuildList,{
        type: '0',
        buildId: e,
        contentType: 'application/json;charset=utf-8'
      }).then(res => {
        this.apartmentList = res.result;
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.searchDiv{
  background-color: white;
  width: calc(100% - 10px);
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
}
.bottom{
  width: 100%;
  margin-top: 20px;
  height: calc(100vh - 148px);
  overflow: auto;
  font-size: 14px;
}
.bottom2{
  width: calc(100% - 10px);
  margin-top: 20px;
  height: calc(100vh - 158px);
  overflow: auto;
  background-color: white;
  font-size: 14px;
}
::v-deep .table .el-table__body-wrapper{
  height: calc(100vh - 217px);
  overflow-y: auto;
}

.bottom-div {
  width: 100%;
  background-color: white;
  display: flex;
  cursor: pointer;
  height: 40vh;
  margin-bottom: 20px;
  border-radius: 5px;
  padding: 10px;
  transition: background-color 0.3s;
}


.bottom-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.capacity {
  margin-bottom: 20%;
}

//.image-container {
//  width: 80%;
//  margin-bottom: 10px;
//}

//.image {
//  width: 100%;
//  height: 100%;
//  object-fit: cover;
//}

.text-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis !important;
  padding: 0 10px;
}

.isOnline {
  //position: relative;
  //top: -10px;
  //right: -46%;
  padding: 2px 5px;
  //font-size: 12px;
  //line-height: 1;
  background-color: red;
  //color: white;
  //border-radius: 2px;
}

.isAbnormal {
  padding: 2px 5px;
  background-color: orange;
}
.tableIsAbnormal {
  padding: 2px 5px;
  background-color: orange;
  top:0;
  left:50%;
  border-radius: 2px;
  position: absolute;
  font-size: 12px;
  line-height: 1;
  color: white;
}

.carousel{
  border-radius: 2px;
  position: relative;
  top: -10px;
  left: 46%;
  font-size: 12px;
  line-height: 1;
  color: white;
  width: 34px;
}
.tableCarousel{
  border-radius: 2px;
  position: absolute;
  font-size: 12px;
  line-height: 1;
  color: white;
  width: 34px;
  top:0;
  left:40%;
}

.bottom-right {
  flex: 1;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //padding-top: 25px;
}

.right-div{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -16px;
}

.consumption-item {
  margin-bottom: 15px;
}

.consumption-title {
  //font-size: 12px;
}

.consumption-value {
  margin-top: 10px;
  font-weight: bold;
  font-size: 16px;
}

.fill {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00ff00; /* 设置你想要的填充颜色 */
  transform-origin: bottom;
  //transform: scaleY(var(--fill-height));
}
.image-container {
  height: 153px;
  margin-bottom: 10px;
  width: 115px;
}

.image {
  width: 100%;
  height: auto;
  object-fit: cover;
  background-color: transparent;
}
//.bottom-div {
//  display: flex;
//  align-items: center;
//  justify-content: space-between;
//  background-color: #fff;
//  padding: 10px;
//  border-radius: 5px;
//  cursor: pointer;
//  transition: background-color 0.3s;
//}
//
//.bottom-div:hover {
//  background-color: #f2f2f2;
//}
//
//.image-container {
//  position: relative;
//  width: 100%;
//  text-align: center;
//}
//
//.image {
//  width: 80%;
//  max-height: 200px;
//  object-fit: cover;
//  margin-bottom: 10px;
//}
//
//.name {
//  font-size: 16px;
//  font-weight: bold;
//  text-align: center;
//  overflow: hidden;
//  text-overflow: ellipsis;
//  white-space: nowrap;
//}
//
//.offline-status {
//  position: absolute;
//  top: 10px;
//  right: 10px;
//  padding: 5px 10px;
//  background-color: #f44336;
//  color: #fff;
//  border-radius: 3px;
//  font-size: 12px;
//  transition: opacity 0.3s;
//}
//
//.offline-status:hover {
//  opacity: 0.8;
//}
//
//.consumption-item {
//  margin-top: 10px;
//}
//
//.consumption-title {
//  font-weight: bold;
//}
//
//.consumption-value {
//  margin-top: 5px;
//}
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
  //padding: 0 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.item {
  width: 100%;
  text-align: center;
}

.left {
  width: 30%;
}

.left img {
  width: 100%;
  height: auto;
}

.right {
  width: 70%;
}

.title {
  font-weight: bold;
  margin-bottom: 5px;
}

.info {
  margin-bottom: 3px;
}
.icon-list{
  display: flex;
  border: 1px solid black;
  border-left: none;
  height: 32px;
}
.icon-list div{
  cursor: pointer;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-left: solid 1px black;
}
.isList-active{
  background-color: #3495BF;
  color: white;
}
::v-deep .table tr{
  cursor: pointer;
}
</style>
